<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <p v-if="preloader && requestServe" class="text-center">
        Este proceso puede llevar un tiempo. <br />
        <span class="font-weight-bold">Procesando: {{ loading }}% </span> 
      </p>
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        enctype="multipart/form-data"
        :data-url="
          selectedUrl
            ? `/vigilancesreview/vigilances/startVigilance`
            : `/vigilancesreview/vigilances/startVigilance`
        "
      >
        <div class="row text-center">
          <div class="col-12">
            <div class="form-group">
              <legend>
                <label class="text-primary"
                  >Iniciar {{msgType}}.</label
                >
              </legend>
              <div>
                <br>
                <h4>{{msgInfo}}</h4>
                 <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Comenzar
      </button> 
              </div>

              <div>
                  <app-note
              class="pt-2 clearfix"
              content-type="html"
              note-type="note-warning"
              :notes="[msgNote]"
            />
              </div>
            </div>
          </div>
        </div>

      </form>
    </template>

    <template slot="footer">
      <br>
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>

    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import axios from 'axios';

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accAppReplicaId: Number,
    msgInfo: String,
    msgType: String,
    msgNote: String,
  },
  data() {
    return {
      preloader: false,
      accApp: null,
      loading: 0,
      inputs: {},
      requestServe: false,
      file_evaluation_historical: [],
      sampling_plan_file_historical: [],
      modalId: "vigilance-modal-start",

    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    this.inputs.idAccApp = this.accAppReplicaId;
    this.getData();
  },
  methods: {
    submit() {
      this.preloader = true;
      this.requestServe = true;
      let url = '/vigilancesreview/vigilances/startVigilance';
      let options = {
        method: 'PATCH',
        url: url,
        data: this.inputs
      }
      // Si tiene pendiente aun el guradado por que se perdio la conexion o otro error
      // Informamos que haga el guardado por lotes a partir de donde se quedo
      if(this.accApp.is_save_lots){
        options.url = options.url + `?page=${this.accApp.next_lot}`;
      }


      let attempts = 0;
      async function request(options,toastr,loading,num = 0){
        let info = null;
        try{
            const response = await axios.request(options);
            info = await response.data;
            if(info.message === 'B'){
              return;
            }
            if(info.finally){
              if(info.message === 'Renovación'){
                return;
              }
              throw Error(info.message);
            }

            if(info.page === info.lastPage){
              return;
            }

            if(!info.repeat){
                if(num > 1){
                  options.url = options.url.replace(/\?page=[0-9]+/,`?page=${info.page + 1}`);
                }else {
                  options.url = url + `?page=${ info.page + 1}`;
                }
                return request(options,toastr,loading,info.page);
            }else{
                attempts++;
                if(attempts === 5){
                  throw Error('Error desconocido, por favor intentelo mas tarde.');
                  return;
                }
                return request(options,toastr,loading);
            }
        }catch(e){
          throw Error(e.message);
          return;
        }finally{
          loading(info.porcent);
        }
      }
      
      request(options,this.$toastr,setLoading,this.accApp.is_save_lots ? this.accApp.next_lot : 0)
      .then(() => {
        this.afterSuccess({});
        this.afterFinalResponse();
      })
      .catch(e => {
        this.$toastr.e(e.message);
        this.$hub.$emit("reload-" + this.tableId);
        this.afterFinalResponse();
      })
      .finally(() => {
        this.preloader = false;
        this.requestServe = false;
      });
      const self = this;
      function setLoading(porcent){
        self.loading = porcent;
      }
      
    },

    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    afterSuccessFromGetEditData({ data: data }) {
      this.preloader = false;
    },
    getData(){
      this.preloader = true;
      axios.get(this.selectedUrl)
      .then((response) => {
        this.preloader = true;
        this.accApp = response.data;
        this.preloader = false
      })
      .finally(() => {
        
      }
      );
      
    }
  },
};
</script>